import {  memo  } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Iframe from "react-iframe";
import Box from '@mui/material/Box';
import Modal from 'react-modal';


const Insta360 = memo((props) => {
    const {isOpen , modalClose , url} = props;
    Modal.setAppElement('#root');
    return (
        url && isOpen &&
        <>
        <Modal 
            className="modal-wrap" 
            style={{
                overlay: {
                  backgroundColor: 'rgba(0, 0, 0, 0.75)'
                }
            }}
            sx={{ pointerEvents: 'none' }}                
            isOpen={isOpen}>
            <Box className="insta360wrap" sx={{xIndex:200000}}>
                <IconButton 
                    sx={{position:'absolute',right:"-5px" ,top:"-10px",color:'white', zIndex:100010}}
                    size="large"
                >
                    <CloseIcon onClick={modalClose} />
                </IconButton>
                <Iframe
                    className="embed_iframe"
                    url={url + "?e=true&locale=en-us"} 
                    width="666px"
                    height='413px'
                    frameborder="0"
                    scrolling="no"
                />
            </Box>
        </Modal>
        </>
    )    
});
export default Insta360